import { API_TOKEN, SERVER_URL } from "../settings";
import { NyntaxHttpStore } from "./client";

/** Single shared client for the backend API, used by the upload queue and
 * anywhere else that needs to talk to the server directly (e.g. pushing a
 * metadata edit outside the upload flow). */
export const httpStore = new NyntaxHttpStore(SERVER_URL, API_TOKEN);
